/**
 * Copyright © 2018 Emu Analytics
 */

export class FlowEngineError extends Error {
  error: object | null;
  statusCode: number;

  constructor(message: string, underlyingError: Error | null = null, statusCode = 500) {
    super(message || 'Unknown Error');

    Object.setPrototypeOf(this, FlowEngineError.prototype);

    this.statusCode = statusCode;
    this.error = underlyingError;
  }
}
